import { z } from 'zod';

// `isIncomeVerified` is optional and false-only from the FE. The BE is the
// sole authority for awarding a positive verdict — it derives the `true`
// case server-side from declaredIncome vs aiIncomeCalculated (+/-10%). The
// FE can only override with an explicit `false` (skip / acknowledged
// unverified) — submitting `true` is rejected here.
export const submitTitleOwnerIncomeSchema = z
  .object({
    applicationId: z.string().min(1, 'applicationId is required'),
    ownershipDisputed: z.boolean().optional().default(false),
    owners: z
      .array(
        z.object({
          id: z.string().min(1, 'owner id is required'),
          declaredIncome: z.number().nonnegative('declaredIncome must be ≥ 0'),
          isIncomeVerified: z
            .literal(false)
            .nullish()
            .describe(
              'Optional. Only false is accepted (explicit skip / acknowledged unverified). The BE derives the true verdict server-side; submitting true is rejected.',
            ),
          // CT-2966: pensioner declaration from the $0-income prompt. true marks
          // the owner income-verified (skips the ±10% check) and is sent to
          // finPOWER as BHESLPensioner.
          isPensioner: z.boolean().nullish(),
        }),
      )
      .default([]),
  })
  .superRefine((data, ctx) => {
    if (!data.ownershipDisputed && data.owners.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.too_small,
        minimum: 1,
        type: 'array',
        inclusive: true,
        message: 'At least one owner is required when ownership is not disputed',
        path: ['owners'],
      });
    }
  });
